<div id="wrapper">
    <app-navbar></app-navbar>

    <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

    <div class="content-page">
        <div class="content">
            <div class="content-pane">
                <div class="container-fluid">
                    <div class="breadcrumb">
                        <span class="breadcrumb-item">
                            <a href="javascript:void(0)">PayEXAP</a>
                        </span>
                        <span class="px-2">
                            <i class="ri-arrow-right-s-line"></i>
                        </span>
                        <span class="breadcrumb-item">
                            <a routerLink="/change-requests">Change Requests</a>
                        </span>
                        <span class="px-2">
                            <i class="ri-arrow-right-s-line"></i>
                        </span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a href="javascript:void(0)">{{ isResubmitMode ? "Edit" : "New" }}</a>
                        </span>
                    </div>

                    <div class="row negative-margin">
                        <div class="col-md-12">
                            <app-jsw-auth-banner></app-jsw-auth-banner>

                            <div
                                *ngIf="errorMsg && !(jswAuthFailed$ | async)"
                                class="alert alert-danger session-text text-center"
                                role="alert"
                            >
                                {{ errorMsg }}
                            </div>

                            <div
                                *ngIf="loadError && !(jswAuthFailed$ | async)"
                                class="alert alert-warning session-text text-center"
                                role="alert"
                            >
                                {{ loadError }}
                            </div>

                            <div
                                *ngIf="!(jswAuthFailed$ | async)"
                                class="card manage-invoice change-request-create"
                            >
                                <div class="card-body">
                                    <div class="pane-header mb-3">
                                        <div class="row align-items-center">
                                            <div class="col-md-8">
                                                <h4 class="mt-2">{{ isResubmitMode ? "Edit change request" : "Create Change Request" }}</h4>
                                                <p class="text-muted mb-0 mt-1">
                                                    <ng-container *ngIf="!isResubmitMode">
                                                        Update only the fields that need to change. Untouched values will not be sent.
                                                    </ng-container>
                                                    <ng-container *ngIf="isResubmitMode">
                                                        Fields from your previous submission are pre-filled. Highlighted fields were updated last time; adjust as needed and resubmit.
                                                    </ng-container>
                                                </p>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="actions-pane float-end mt-2">
                                                    <button
                                                        type="button"
                                                        class="btn btn-outline-secondary me-2"
                                                        (click)="cancel()"
                                                        [disabled]="isSubmitting"
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="btn btn-invoice"
                                                        (click)="submit()"
                                                        [disabled]="submitDisabled"
                                                        [title]="submitButtonTitle"
                                                    >
                                                        <i class="ri-send-plane-line me-1"></i>
                                                        {{ isSubmitting ? "Submitting..." : "Submit" }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <form [formGroup]="form" *ngIf="!loadError" class="cr-form">
                                        <ng-template #crFieldControl let-field>
                                            <ng-container *ngIf="isDateField(field); else crTextControl">
                                                <input
                                                    type="date"
                                                    class="form-control"
                                                    [id]="field.controlName"
                                                    [formControlName]="field.controlName"
                                                    [title]="fieldInputTitle(field.controlName, field.validationHint)"
                                                    [class.is-invalid]="fieldHasValidationError(field.controlName)"
                                                />
                                            </ng-container>
                                            <ng-template #crTextControl>
                                                <input
                                                    class="form-control"
                                                    [id]="field.controlName"
                                                    [type]="field.type === 'number' ? 'number' : 'text'"
                                                    [formControlName]="field.controlName"
                                                    [title]="fieldInputTitle(field.controlName, field.validationHint)"
                                                    [ngbTooltip]="fieldValidationTooltip(field.controlName)"
                                                    [disableTooltip]="!fieldHasValidationError(field.controlName)"
                                                    container="body"
                                                    placement="top"
                                                    triggers="hover"
                                                    [class.is-invalid]="fieldHasValidationError(field.controlName)"
                                                />
                                            </ng-template>
                                        </ng-template>

                                        <ng-container *ngFor="let section of sections">
                                            <div
                                                class="cr-section mb-4"
                                                [class.cr-section--readonly]="section.id === 'requestor'"
                                            >
                                                <h5 class="cr-section-title">{{ section.title }}</h5>
                                                <ng-container *ngIf="section.id === 'requestor' && requestorOptions.length > 1">
                                                    <div class="row mb-3">
                                                        <div class="col-12">
                                                            <label class="form-label" for="requestor-select">Select Requestor</label>
                                                            <ng-select
                                                                class="cr-requestor-select"
                                                                inputId="requestor-select"
                                                                [items]="requestorSelectItems"
                                                                bindLabel="label"
                                                                [ngModel]="selectedRequestorItem"
                                                                (ngModelChange)="onRequestorChange($event)"
                                                                [ngModelOptions]="{standalone: true}"
                                                                [searchable]="true"
                                                                [clearable]="false"
                                                            ></ng-select>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                                <div class="row" *ngIf="section.id === 'requestor'">
                                                    <div
                                                        class="col-md-6 col-lg-4 cr-field"
                                                        *ngFor="let field of section.fields"
                                                        [class.cr-field--resubmit-highlight]="fieldHasResubmitHighlight(field.key) && !fieldHasValidationError(field.controlName)"
                                                        [class.cr-field--validation-error]="fieldHasValidationError(field.controlName)"
                                                    >
                                                        <label class="form-label" [attr.for]="field.controlName">
                                                            {{ field.label }}
                                                        </label>
                                                        <ng-container
                                                            *ngTemplateOutlet="crFieldControl; context: { $implicit: field }"
                                                        ></ng-container>
                                                        <div
                                                            *ngIf="fieldHasValidationError(field.controlName)"
                                                            class="invalid-feedback d-block"
                                                        >
                                                            {{ fieldValidationErrorMessage(field.controlName) }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <ng-container *ngIf="section.id === 'vendor'">
                                                    <div
                                                        class="cr-field-group"
                                                        *ngFor="let group of documentFieldGroups"
                                                    >
                                                        <h6 class="cr-field-group-title">{{ group.title }}</h6>
                                                        <div class="row">
                                                            <div
                                                                class="col-md-6 col-lg-4 cr-field"
                                                                *ngFor="let field of getGroupFields(section, group)"
                                                                [class.cr-field--resubmit-highlight]="fieldHasResubmitHighlight(field.key) && !fieldHasValidationError(field.controlName)"
                                                                [class.cr-field--validation-error]="fieldHasValidationError(field.controlName)"
                                                            >
                                                                <label class="form-label" [attr.for]="field.controlName">
                                                                    {{ field.label }}
                                                                </label>
                                                                <ng-container
                                                                    *ngTemplateOutlet="crFieldControl; context: { $implicit: field }"
                                                                ></ng-container>
                                                                <div
                                                                    *ngIf="fieldHasValidationError(field.controlName)"
                                                                    class="invalid-feedback d-block"
                                                                >
                                                                    {{ fieldValidationErrorMessage(field.controlName) }}
                                                                </div>
                                                                </div>
                                                            </div>
                                                        <app-cr-document-upload
                                                            [groupId]="group.id"
                                                            [requiredDocsLabel]="group.supportingDocumentLabel"
                                                            [files]="documentsForGroup(group.id)"
                                                            (filesChange)="onDocumentsChange(group.id, $event)"
                                                            [disabled]="isSubmitting || !isDocumentUploadEnabled(group.id)"
                                                            [required]="isDocumentUploadRequired(group.id)"
                                                            [showRequiredError]="showDocumentErrors"
                                                        ></app-cr-document-upload>
                                                    </div>

                                                    <div class="row">
                                                        <div
                                                            class="col-md-6 col-lg-4 cr-field"
                                                            *ngFor="let field of getStandaloneVendorFields(section)"
                                                            [class.cr-field--resubmit-highlight]="fieldHasResubmitHighlight(field.key) && !fieldHasValidationError(field.controlName)"
                                                            [class.cr-field--validation-error]="fieldHasValidationError(field.controlName)"
                                                        >
                                                            <label class="form-label" [attr.for]="field.controlName">
                                                                {{ field.label }}
                                                            </label>
                                                            <ng-container
                                                                *ngTemplateOutlet="crFieldControl; context: { $implicit: field }"
                                                            ></ng-container>
                                                            <div
                                                                *ngIf="fieldHasValidationError(field.controlName)"
                                                                class="invalid-feedback d-block"
                                                            >
                                                                {{ fieldValidationErrorMessage(field.controlName) }}
                                                            </div>
                                                            <app-cr-document-upload
                                                                *ngIf="field.supportingDocuments.length"
                                                                [groupId]="fieldUploadGroupId(field.key)"
                                                                [requiredDocsLabel]="field.supportingDocuments.join('; ')"
                                                                [files]="documentsForGroup(fieldUploadGroupId(field.key))"
                                                                (filesChange)="onDocumentsChange(fieldUploadGroupId(field.key), $event)"
                                                                [disabled]="isSubmitting || !isDocumentUploadEnabled(fieldUploadGroupId(field.key))"
                                                                [required]="isDocumentUploadRequired(fieldUploadGroupId(field.key))"
                                                                [showRequiredError]="showDocumentErrors"
                                                            ></app-cr-document-upload>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </ng-container>

                                        <div
                                            class="cr-section mb-4"
                                            [class.cr-section--resubmit-highlight]="bankSectionHasResubmitHighlight()"
                                        >
                                            <div class="d-flex align-items-center justify-content-between mb-2">
                                                <h5 class="cr-section-title mb-0">Vendor Bank Details</h5>
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-outline-primary"
                                                    (click)="addBankRow()"
                                                    [disabled]="isSubmitting"
                                                >
                                                    <i class="ri-add-line me-1"></i>
                                                    Add Bank Row
                                                </button>
                                            </div>

                                            <div
                                                *ngIf="bankRows.length === 0"
                                                class="text-muted small"
                                            >
                                                No bank rows. Click "Add Bank Row" to include bank changes in this request.
                                            </div>

                                            <ng-container formArrayName="VENDOR_BANK_DETAILS">
                                                <div
                                                    class="row cr-bank-row align-items-end g-2"
                                                    *ngFor="let _bankCtrl of bankRows.controls; let i = index"
                                                    [formGroupName]="i"
                                                >
                                                    <div
                                                        class="col-12 col-sm-6 col-md-4 col-lg-3 cr-field"
                                                        *ngFor="let bankKey of bankRowKeys"
                                                        [class.cr-field--validation-error]="bankFieldHasValidationError(i, bankKey)"
                                                    >
                                                        <label class="form-label" [attr.for]="'bank-' + i + '-' + bankKey">
                                                            {{ bankFieldLabel(bankKey) }}<span *ngIf="bankFieldRequired(bankKey)" class="text-danger ms-1" aria-hidden="true">*</span>
                                                        </label>
                                                        <ng-container *ngIf="bankKey === 'IFSC_CODE'; else bankFieldDefaultInput">
                                                            <div class="input-group cr-ifsc-input-group">
                                                                <input
                                                                    class="form-control"
                                                                    type="text"
                                                                    [id]="'bank-' + i + '-' + bankKey"
                                                                    [formControlName]="bankKey"
                                                                    (blur)="onIfscBlur(i)"
                                                                    [title]="bankFieldInputTitle(i, bankKey, bankValidationHint(bankKey))"
                                                                    [ngbTooltip]="bankFieldValidationTooltip(i, bankKey)"
                                                                    [disableTooltip]="!bankFieldHasValidationError(i, bankKey)"
                                                                    container="body"
                                                                    placement="top"
                                                                    triggers="hover"
                                                                    [class.is-invalid]="bankFieldHasValidationError(i, bankKey)"
                                                                />
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-outline-secondary cr-ifsc-fetch-btn"
                                                                    (click)="fetchIfscDetails(i)"
                                                                    [disabled]="!canFetchIfsc(i) || isSubmitting"
                                                                    title="Fetch bank details from IFSC"
                                                                >
                                                                    <span
                                                                        *ngIf="ifscLookupLoading[i]"
                                                                        class="spinner-border spinner-border-sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    ></span>
                                                                    <span *ngIf="!ifscLookupLoading[i]">Fetch</span>
                                                                </button>
                                                            </div>
                                                            <div
                                                                *ngIf="ifscLookupErrors[i]"
                                                                class="text-danger small mt-1"
                                                            >
                                                                {{ ifscLookupErrors[i] }}
                                                            </div>
                                                        </ng-container>
                                                        <ng-template #bankFieldDefaultInput>
                                                            <input
                                                                class="form-control"
                                                                type="text"
                                                                [id]="'bank-' + i + '-' + bankKey"
                                                                [formControlName]="bankKey"
                                                                [title]="bankFieldInputTitle(i, bankKey, bankValidationHint(bankKey))"
                                                                [ngbTooltip]="bankFieldValidationTooltip(i, bankKey)"
                                                                [disableTooltip]="!bankFieldHasValidationError(i, bankKey)"
                                                                container="body"
                                                                placement="top"
                                                                triggers="hover"
                                                                [class.is-invalid]="bankFieldHasValidationError(i, bankKey)"
                                                            />
                                                        </ng-template>
                                                        <div
                                                            *ngIf="bankFieldHasValidationError(i, bankKey)"
                                                            class="invalid-feedback d-block"
                                                        >
                                                            {{ bankFieldValidationErrorMessage(i, bankKey) }}
                                                        </div>
                                                    </div>
                                                    <div class="col-12 cr-bank-documents">
                                                        <app-cr-document-upload
                                                            [groupId]="bankRowGroupId(i)"
                                                            [requiredDocsLabel]="bankDocumentLabel"
                                                            [files]="documentsForGroup(bankRowGroupId(i))"
                                                            (filesChange)="onDocumentsChange(bankRowGroupId(i), $event)"
                                                            [disabled]="isSubmitting || !isDocumentUploadEnabled(bankRowGroupId(i))"
                                                            [required]="isDocumentUploadRequired(bankRowGroupId(i))"
                                                            [showRequiredError]="showDocumentErrors"
                                                        ></app-cr-document-upload>
                                                    </div>
                                                    <div
                                                        *ngIf="canRemoveBankRow(i)"
                                                        class="col-12 col-sm-6 col-md-4 col-lg-2 cr-field cr-bank-actions"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="btn btn-sm btn-outline-danger"
                                                            (click)="removeBankRow(i)"
                                                            [disabled]="isSubmitting"
                                                            title="Remove this bank row"
                                                        >
                                                            <i class="ri-delete-bin-line"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
